"use client";

import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import axios from "axios";
import { Service } from "@/app/shared/type";
import { API_BASE_URL, USE_BACKEND } from "@/app/api/variable";
import servicesData from "@/app/data/service.json";

interface MobileServicesMenuProps {
  onItemClick?: () => void;
}

export default function MobileServicesMenu({ onItemClick }: MobileServicesMenuProps) {
  const [services, setServices] = useState<Service[]>([]);
  const [loading, setLoading] = useState(true);
  const router = useRouter();

  useEffect(() => {
    const fetchServices = async () => {
      try {
        if (USE_BACKEND) {
          const response = await axios.get<Service[]>(`${API_BASE_URL}/service`);
          setServices(response.data || []);
        } else {
          setServices((servicesData as unknown) as Service[]);
        }
      } catch (error) {
        console.error("Error fetching services:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchServices();
  }, []);

  const handleNavigation = (slug: any) => {
    if (onItemClick) onItemClick();
    const currentPath = window.location.pathname;
    if (currentPath !== "/services") {
      router.push(`/services#${slug}`);
      // Scroll after page navigation
      setTimeout(() => {
        const section = document.getElementById(slug);
        if (section) section.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 700);
    } else {
      // If  on /services path
      const section = document.getElementById(slug);
      if (section) {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        window.location.hash = slug;
        setTimeout(() => {
          const section = document.getElementById(slug);
          section?.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 400);
      }
    }
  };

  if (loading) {
    return (
      <div className="space-y-1 ml-4 mb-2">
        {[...Array(6)].map((_, idx) => (
          <div key={idx} className="h-4 w-40 bg-gray-800 rounded animate-pulse" />
        ))}
      </div>
    );
  }

  return (
    <div className="ml-4 mb-2 space-y-1">
      {services.map((service) => (
        <button
          key={service.slug}
          onClick={() => handleNavigation(service.slug)}
          className="block w-full text-left py-1 text-sm text-gray-300 hover:text-cyan-300 transition-colors"
        >
          {service.name}
        </button>
      ))}
    </div>
  );
}
